// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedGaugeMeterDefaultAddOnWarning_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM17.771 15.3886L19.7292 14.75V19.6456H17.771V15.3886ZM17.771 20.6246H19.7292V22.5828H17.771V20.6246Z" fill="#FDCA40"/>
  <path d="M17.77 15.3886 19.7282 14.75V19.6456H17.77V15.3886ZM17.77 20.6246H19.7282V22.5828H17.77V20.6246Z" fill="#1A2329"/>
  <path d="M4.84058 6.36835C6.47032 5.15491 8.41857 4.34536 10.5371 4.08789L10.4525 6.11863C8.87167 6.3642 7.41331 6.98005 6.16887 7.87474L4.84058 6.36835ZM19.1592 6.3683C17.5295 5.15491 15.5813 4.3454 13.4629 4.08791L13.5475 6.11865C15.1282 6.36423 16.5865 6.98006 17.8309 7.87469L19.1592 6.3683ZM12.5 5H11.5L11.0035 16.9155C11.0012 16.9433 11 16.9715 11 17 11 17.3905 11.2238 17.7286 11.5501 17.8933 11.6995 16.6242 12.1767 15.4553 12.8947 14.4738L12.5 5ZM20.6589 7.69238C22.175 9.27209 23.263 11.2658 23.7364 13.487 22.9957 12.7851 22.107 12.2378 21.122 11.8969 20.6728 10.8999 20.065 9.98982 19.3306 9.19876L20.6589 7.69238ZM4.66931 9.19882C3.01284 10.9833 2 13.3736 2 16.0004 2 17.0456 2.16035 18.0534 2.4578 19.0004H.378052C.131259 18.0416 0 17.0363 0 16.0004 0 12.776 1.27175 9.84859 3.34102 7.69245L4.66931 9.19882Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedGaugeMeterDefaultAddOnWarning is a generated icon component.
 */
let IconMedGaugeMeterDefaultAddOnWarning = IconMedGaugeMeterDefaultAddOnWarning_1 = class IconMedGaugeMeterDefaultAddOnWarning extends IconBaseElement {
    render() {
        return html `${IconMedGaugeMeterDefaultAddOnWarning_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedGaugeMeterDefaultAddOnWarning.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedGaugeMeterDefaultAddOnWarning = IconMedGaugeMeterDefaultAddOnWarning_1 = __decorate([
    customElement('zui-icon-med-gauge-meter-default-add-on-warning')
], IconMedGaugeMeterDefaultAddOnWarning);
export { IconMedGaugeMeterDefaultAddOnWarning };
